{
  "en": {
    "answers": [
      {
        "id": 1329065,
        "text": "### Correct Matching:\n\n|  | **Term → Category**   |\n| ------- | -------------------- |\n| A → H  | Heart → Pump organ   |\n|  B → G    | Lung → Respiratory organ  |\n| C → F    | Brain → Control organ   |\n|  D → E     | Bone → Supporting organ  |",
        "is_right": true
      }
    ],
    "tags": [
      {
        "id": 156068,
        "name": "Sample Question"
      },
      {
        "id": 156081,
        "name": "Freetext"
      },
      {
        "id": 156100,
        "name": "Matching"
      }
    ],
    "text": "|  | **Term** |  | **Category**   |\n| ------- | ----------- | ------- | --------------- |\n| A       | Heart        | E       | Supporting organ        |\n| B       | Lung       | F       |   Control organ  |\n| C       | Brain      | G       | Respiratory organ  |\n| D       | Bone     | H       |   Pump organ   |\n\n### Assign the terms to the correct categories.",
    "is_poll_question": false,
    "type": 3,
    "created_at": "2025-09-02T18:04:39.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:55:40.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "max_score": 8,
    "max_num_characters": 200,
    "weblink": "https://quizacademy.de/tipps/#Tipps%20f%C3%BCr%20Quizfragen",
    "has_weblink": true,
    "explanation": "### Sample Answer:\n\n### Correct Matching:\n\n|  | **Term → Category**   |\n| ------- | -------------------- |\n| A → H  | Heart → Pump organ   |\n|  B → G    | Lung → Respiratory organ  |\n| C → F    | Brain → Control organ   |\n|  D → E     | Bone → Supporting organ  |\n\n* Matching questions are particularly suitable for linking **terms, definitions, functions, or categories**.\n* They encourage **connected thinking** and provide a varied alternative to classical SC or MC questions.\n\n### It is important to keep the number of items manageable (ideally 3–6 matchings) so the question does not become too confusing.",
    "has_explanation": true,
    "num_answers": 1
  },
  "de": {
    "answers": [
      {
        "id": 1329065,
        "text": "### Correct Matching:\n\n|  | **Term → Category**   |\n| ------- | -------------------- |\n| A → H  | Heart → Pump organ   |\n|  B → G    | Lung → Respiratory organ  |\n| C → F    | Brain → Control organ   |\n|  D → E     | Bone → Supporting organ  |",
        "is_right": true
      }
    ],
    "tags": [
      {
        "id": 156068,
        "name": "Sample Question"
      },
      {
        "id": 156081,
        "name": "Freetext"
      },
      {
        "id": 156100,
        "name": "Matching"
      }
    ],
    "text": "|  | **Term** |  | **Category**   |\n| ------- | ----------- | ------- | --------------- |\n| A       | Heart        | E       | Supporting organ        |\n| B       | Lung       | F       |   Control organ  |\n| C       | Brain      | G       | Respiratory organ  |\n| D       | Bone     | H       |   Pump organ   |\n\n### Assign the terms to the correct categories.",
    "is_poll_question": false,
    "type": 3,
    "created_at": "2025-09-02T18:04:39.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:55:40.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "max_score": 8,
    "max_num_characters": 200,
    "weblink": "https://quizacademy.de/tipps/#Tipps%20f%C3%BCr%20Quizfragen",
    "has_weblink": true,
    "explanation": "### Sample Answer:\n\n### Correct Matching:\n\n|  | **Term → Category**   |\n| ------- | -------------------- |\n| A → H  | Heart → Pump organ   |\n|  B → G    | Lung → Respiratory organ  |\n| C → F    | Brain → Control organ   |\n|  D → E     | Bone → Supporting organ  |\n\n* Matching questions are particularly suitable for linking **terms, definitions, functions, or categories**.\n* They encourage **connected thinking** and provide a varied alternative to classical SC or MC questions.\n\n### It is important to keep the number of items manageable (ideally 3–6 matchings) so the question does not become too confusing.",
    "has_explanation": true,
    "num_answers": 1
  }
}
